<template>
	<div>    
		<header class="mdc-top-app-bar top-app-bar top-header">
				<div class="mdc-top-app-bar__row">
					<section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-start">
						<button class="material-icons mdc-top-app-bar__navigation-icon mdc-icon-button hide-desktop navToggle"
										aria-label="Open navigation menu">menu</button>
						<span class="mdc-top-app-bar__title t-subtitle4 pdl-12 cursor-pointer">{{title}}</span>
					</section>
					<section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-end" role="toolbar">
						<div class=" t-body2 t-color-white pdr-18 cursor-pointer">{{$t('329')}}</div>
					</section>
				</div>
    </header>
<div class="d-flex h-full flex-column">
		<main class="main-wrapper full flex-grow-1 scroll-y">
			<div class="container container--small pdt-30 ">
				<form @submit.prevent="changePassword()" novalidate>
				<div class="pdl-24 pdr-24">
								<div class="t-headline11 font-m mgt-20 mgb-8">{{$t('329')}}</div>
								<div class="body1 font-r t-color-bodyGrayA">{{$t('330')}}</div>
								<div class="mgt-40 mgb-8">
												<label
																class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full customize-input h-46 "
																data-mdc-auto-init="MDCTextField" 
																:class="submitState && currentPasswordInvalidCheck ? 'mdc-text-field--invalid' : ''"
																id="email">
																<span class="mdc-notched-outline">
																				<span class="mdc-notched-outline__leading"></span>
																				<span class="mdc-notched-outline__notch">
																								<span class="mdc-floating-label" id="password-message">{{$t('331')}}</span>
																				</span>
																				<span class="mdc-notched-outline__trailing"></span>
																</span>
																				<input class="mdc-text-field__input" type="password" aria-labelledby="password-message"
																						v-model="currentPassword"
																						v-validate="'required'"
																						ref="currentPassword"
																						id="currentPassword"
																						name="currentPassword"
																						maxlength="50"
																				required >
																<i class="material-icons mdc-text-field__icon mdc-text-field__icon--trailing" tabindex="0"
																				role="button">report_problem</i>
												</label>
												<div class="mdc-text-field-helper-line">
																<div class="mdc-text-field-helper-text mdc-text-field-helper-text--validation-msg t-helper font-r"
																				id="my-helper-id" aria-hidden="true" 	
																				:class="submitState && currentPasswordInvalidCheck ? 't-color-mainBtn' : ''">현재 비밀번호를 입력하세요
																</div>
												</div>
								</div>

								<div class="divider"></div>
								<div class="mgt-16">
												<label
																class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full customize-input h-46 "
																data-mdc-auto-init="MDCTextField" 
																:class="submitState && newPasswordInvalidCheck ? 'mdc-text-field--invalid' : ''"
																id="newPasswordEl">
																<span class="mdc-notched-outline">
																				<span class="mdc-notched-outline__leading"></span>
																				<span class="mdc-notched-outline__notch">
																								<span class="mdc-floating-label" >{{$t('332')}}</span>
																				</span>
																				<span class="mdc-notched-outline__trailing"></span>
																</span>
																<input class="mdc-text-field__input" type="password" 
																		aria-labelledby="password-message"
																		v-model="newPassword"
																		v-validate="'required|min:8|verify_password'"
																		ref="newPassword"
																		id="newPassword"
																		name="newPassword"
																		maxlength="50"
																		required 
																		>
																<i class="material-icons mdc-text-field__icon mdc-text-field__icon--trailing" tabindex="0"
																:class="newPasswordConfirmValidIcon === 'check' ? 'check_show' : ''"
																	role="button">{{newPasswordValidIcon}}</i>
												</label>
												<div class="mdc-text-field-helper-line d-block">
													<div class="mdc-text-field-helper-text mdc-text-field-helper-text--persistent t-helper mdc-text-field-helper-text--validation-msg font-r "
																	:class="submitState && newPasswordInvalidCheck ? 't-color-mainBtn' : ''" >
																	{{$t('333')}}
													</div>
												</div>
								</div>
								<div class="mgt-16">
												<label
																class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full customize-input h-46"
																data-mdc-auto-init="MDCTextField" 
																:class="submitState && newPasswordConfirmInvalidCheck ? 'mdc-text-field--invalid' : ''"
																id="newPasswordConfirmEl">
																<span class="mdc-notched-outline">
																				<span class="mdc-notched-outline__leading"></span>
																				<span class="mdc-notched-outline__notch">
																								<span class="mdc-floating-label" >{{$t('334')}}</span>
																				</span>
																				<span class="mdc-notched-outline__trailing"></span>
																</span>
																				<input class="mdc-text-field__input" type="password" aria-labelledby="password-message"
																						v-model="newPasswordConfirm"
																						v-validate="'required|confirmed:newPassword'"
																						ref="newPasswordConfirm"
																						id="newPasswordConfirm"
																						name="newPasswordConfirm"
																						maxlength="50"
																				required />
																<i class="material-icons mdc-text-field__icon mdc-text-field__icon--trailing" tabindex="0"
																:class="newPasswordConfirmValidIcon === 'check' ? 'check_show' : ''"
																				role="button">{{newPasswordConfirmValidIcon}}</i>
												</label>
												<div class="mdc-text-field-helper-line d-block">
																<div
																				class="mdc-text-field-helper-text mdc-text-field-helper-text--persistent t-helper mdc-text-field-helper-text--validation-msg font-r "
																				:class="submitState && newPasswordInvalidCheck ? 't-color-mainBtn' : ''" >
																					{{submitState && newPasswordConfirmInvalidCheck ? $t('341') : $t('335')}}
																</div>
												</div>
								</div>
								<div class="mgt-30 mgt-50">
												<button class="mdc-button mdc-button--raised bg-mainBtn t-color-mainBtnText mgr-8"
																type="submit">
																<div class="mdc-button__ripple"></div>
																<span class="mdc-button__label t-body2 font-r">{{$t('336')}}</span>
												</button>
												<button class="mdc-button bg-white t-color-secondaryBtnText  " @click="nextChangePassword()" @keypress="nextChangePassword()" tabindex="0">
																<div class="mdc-button__ripple"></div>
																<span class="mdc-button__label t-body2 font-r">{{$t('337')}}</span>
												</button>
								</div>
				</div>
				</form>
			</div>
</main>
    </div>
	</div>
	
</template>

<script>

import {MDCTextField} from '@material/textfield'
import {MDCRipple} from '@material/ripple'
import resetApi from '@/api/resetApi.js'

export default {
	data() {
		return {
			currentPassword: '',
			newPassword: '',
			newPasswordConfirm: '',
			currentPasswordTextField: null,
			newPasswordTextField: null,
			newPasswordConfirmTextField: null,
			submitState: false,
			newPasswordValidIcon: 'report_problem',
			newPasswordConfirmValidIcon: 'report_problem',
			title:null
		}
	},
created(){
	this.title = localStorage.getItem('brandName') || this.$t('329');
//	this.setMaterialUi();
},
	computed : {
		currentPasswordInvalidCheck() {
			let returnValue = false
			if (this.submitState) {
				if (this.errors.has('currentPassword')) {
					returnValue = true
				}else {
					returnValue = false
				}
			}
			this.currentPasswordTextField.valid === !returnValue ? '' : this.currentPasswordTextField.valid = !returnValue
			return returnValue
		},

		newPasswordInvalidCheck() {
			let returnValue = false
			if (this.submitState) {
				if (this.errors.has('newPassword')) {
					returnValue = true
					this.newPasswordValidIcon = 'report_problem'
				}else {
					returnValue = false
					this.newPasswordValidIcon = 'check'
				}
			}
			this.newPasswordTextField.valid === !returnValue ? '' : this.newPasswordTextField.valid = !returnValue
			return returnValue
		},

		newPasswordConfirmInvalidCheck() {
			let returnValue = false
			if (this.submitState) {
				if (this.errors.has('newPasswordConfirm')) {
					returnValue = true
					this.newPasswordConfirmValidIcon = 'report_problem'
				}else {
					returnValue = false
					this.newPasswordConfirmValidIcon = 'check'
				}
			}
			this.newPasswordConfirmTextField.valid === !returnValue ? '' : this.newPasswordConfirmTextField.valid = !returnValue
			return returnValue
		},

	},

	mounted() {
	//	this.setMaterialUi()
				window.mdc.autoInit();
			if(document.querySelector('.mdc-text-field')){
				var textField = new MDCTextField(document.querySelector('.mdc-text-field'));
			}
			const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
				let button = new MDCRipple.attachTo(el)
				return button
			})
this.setMaterialUi();
		this.$refs.currentPassword.focus()
	},

	methods: {
		setMaterialUi() {
			this.currentPasswordTextField = new MDCTextField(document.querySelector('#email'))
			this.currentPasswordTextField.useNativeValidation = false
			this.newPasswordTextField = new MDCTextField(document.querySelector('#newPasswordEl'))
			this.newPasswordTextField.useNativeValidation = false
			this.newPasswordConfirmTextField = new MDCTextField(document.querySelector('#newPasswordConfirmEl'))
			this.newPasswordConfirmTextField.useNativeValidation = false
		},

		changePassword() {
			this.$validator.validateAll().then((resultValid) => {
				this.submitState = true
				if (resultValid) {
						let params = {
							password: this.currentPassword,
							newPassword: this.newPassword
						}
						let responseData = null
						let alertParams = null
						resetApi.changePassword(params).then((response) => {
							responseData = response.data.data
							
							if (responseData) {
								alertParams = {
									title: this.$t('325'), 
									content: this.$t('326'), 
									accept: this.$t('328'), 
								}

								this.$alert(alertParams).then(() => {
									this.$router.push('/home')
								})
							} else {
								this.$snackOpen({contents:this.$t('Todo-비밀번호 변경에 실패하였습니다. 관리자에게 문의 바랍니다.')}).then(() => {})
							}
							
						}).catch((err) => {
							responseData = err.response.data.meta
							this.$snackOpen({contents:this.$t('344'), btnDisplayYN:true, btnDisplay:this.$t('345')}).then(() => {})
							
						})
				}
			})
			
		},

		nextChangePassword() {
			this.$router.push('/home')
		},
	}
}
</script>
<style scoped>
.check_show{
	display: block !important;;
}
</style>